interface CancelConfirmationModalProps {
  isOpen: boolean;
  onKeepEditing: () => void;
  onDiscardChanges: () => void;
}

function CancelConfirmationModal({
  isOpen,
  onKeepEditing,
  onDiscardChanges,
}: CancelConfirmationModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onKeepEditing}
    >
      <div
        className="bg-card border border-border rounded-lg shadow-lg max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="flex items-start justify-between p-6 border-b border-border">
          <h2 className="text-xl" style={{ fontWeight: 'var(--font-weight-semibold)' }}>
            Discard changes?
          </h2>
          <button
            onClick={onKeepEditing}
            className="p-1 hover:bg-muted rounded transition-colors"
            aria-label="Close"
          >
            <svg
              className="w-5 h-5 text-muted-foreground"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-6">
          <p className="text-muted-foreground">
            If you leave now the participant will not be added and any changes will be lost. Are you
            sure you want to continue?
          </p>
        </div>

        {/* Modal Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <button
            onClick={onKeepEditing}
            className="px-4 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/80 transition-colors"
            style={{ fontWeight: 'var(--font-weight-medium)' }}
            data-intercom-target="cancel-confirmation-keep-editing"
          >
            Cancel
          </button>
          <button
            onClick={onDiscardChanges}
            className="px-4 py-2 bg-destructive text-destructive-foreground rounded-md hover:opacity-90 transition-opacity"
            style={{ fontWeight: 'var(--font-weight-medium)' }}
            data-intercom-target="cancel-confirmation-discard-changes"
          >
            Discard Changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default CancelConfirmationModal;
